'use client';

import {styled} from '@mui/material/styles';
import {Typography} from "@mui/material";

const IconStyle = styled(Typography)(({theme}) => ({
    color: theme.palette.custom?.socialIconColor,
    borderRadius: '50%',
    border: `1px solid ${theme.palette.custom?.socialIconColor}`,
    width: '1.5rem',
    height: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all ease-in-out .2s',
    gap:'1.2rem',
    '&:hover': {
        transition: 'all ease-in-out .2s',
        color: theme.palette.custom?.socialIconColorHover,
        border: `1px solid ${theme.palette.custom?.socialIconColorHover}`,
    }
}));

export default IconStyle;
